<template>
	<div>
		<navigation-component></navigation-component>
		<div class="main-content" id="panel">
	  		<header-component></header-component>
	  		<!-- Page content -->

	  		<div class="container-fluid mt-4">
                <div class="row">
                    <div class="col-12">
                        <div class="card mb-4">
                            <!-- Card header -->
                            <div class="card-header">
                                <p>Por favor llene el siguiente formulario</p>
                            </div>
                            <!-- Card body -->
                            <div class="card-body" v-if="usuario">
                                <vue-form :state="formstate" @submit.prevent="update()">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="nombres">Nombre*</label>
                                                    <input type="text" class="form-control" id="nombres" v-model="model.nombre" name="nombres" placeholder="Escribe tu nombre" required>
                                                    <field-messages name="nombres" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">El nombre es requerido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="apellidos">Apellidos*</label>
                                                    <input type="text" class="form-control" name="apellidos" id="apellidos" v-model="model.apellidos" placeholder="Apellidos" required>
                                                    <field-messages name="apellidos" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">Los apellidos son requeridos</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="exampleFormControlSelect1">Empresa/Escuela/Organización</label>
                                                    <b-form-select v-model="model.id_cliente" :options="clients" id="id_cliente" name="id_cliente" value-field="id" text-field="nombre" required></b-form-select>
                                                    <field-messages name="id_cliente" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">Este campo es requerido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label class="form-control-label" for="fecha_nacimiento">Fecha de nacimiento:</label>
                                            <flat-pickr class="form-control" v-model="model.fecha_nacimiento"></flat-pickr>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="id_idioma">Idioma*</label>
                                                    <b-form-select v-model="model.id_idioma" :options="idiomas" id="id_idioma" name="id_idioma" value-field="id" text-field="nombre" required></b-form-select>
                                                    <field-messages name="id_idioma" show="$invalid && $submitted" class="text-danger">
                                                            <div slot="required">El idioma es requerido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="id_pais">País</label>
                                                <b-form-select v-model="model.id_pais" :options="paises" id="id_pais" value-field="id" text-field="nombre" @change="getEstados"></b-form-select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="id_estado">Estado o provincia</label>
                                                <b-form-select v-model="model.id_estado" :options="estados" id="id_estado" value-field="id" text-field="nombre" @change="getCiudades"></b-form-select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="example3cols2Input">Ciudad</label>
                                                <b-form-select v-model="model.id_ciudad" :options="ciudades" id="id_ciudad" value-field="id" text-field="nombre"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="cp">Código postal</label>
                                                <input type="text" class="form-control" v-model="model.cp" id="cp" placeholder="00000">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="telefono">Número de contacto</label>
                                                <input type="text" class="form-control" id="telefono" v-model="model.telefono" placeholder="10 dígitos">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="id_zona_horaria">Zona horaria</label>
                                                <b-form-select v-model="model.id_zona_horaria" :options="zonashorarias" id="id_zona_horaria" value-field="id" text-field="nombre"></b-form-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="email">Correo electrónico*</label>
                                                    <input class="form-control" id="email" name="email" v-model="model.email" placeholder="Dirección de correo válida" type="email" required readonly >
                                                    <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">El correo electrónico es requerido</div>
                                                        <div slot="email">El correo electrónico no es válido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <validate tag="div">
                                                    <label class="form-control-label" for="password_new">Contraseña nueva</label><div class="input-group input-group-merge">
                                                        <input class="form-control" id="password_new" name="password_new" v-model="model.password_new" placeholder="Contraseña" type="password" minlength="8">
                                                        <div class="input-group-append">
                                                            <span class="input-group-text"><i class="fas fa-eye"></i></span>
                                                        </div>
                                                    </div>
                                                    <field-messages name="password" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">La contraseña es requerida</div>
                                                        <div slot="minlength">La contraseña debe de tener mínimo 8 caracteres</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            
                                        </div>
                                    </div>
                                    <div class=" mx-0 d-block"><button class="btn btn-primary center" type="submit">Actualizar</button></div>
                                </vue-form>
                            </div>
                        </div>
                    </div>
                </div>
	  		</div>
	  	</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueForm from "vue-form"
	import NavigationComponent from '@/components/NavigationComponent'
	import HeaderComponent from '@/components/HeaderComponent'
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'Profile',
		components: {
			NavigationComponent, HeaderComponent, flatPickr
		},
		data() {
			return {
                paises: [],
                idiomas: [],
                estados: [],
                ciudades: [],
                zonashorarias: [],
                clients: [],
				formstate: {},
                model: {

                },
                usuario: null,
			}
		},

		methods: {
			async update() {
                this.openLoading()
                await axios.put(`${apiKS}api/usuario-pro/${this.usuario.id}`, { user: this.model }, { headers })
                    .then( response => {
                        Swal.close()
                        this.showMessage('Exito', response.data.message, 'success')
                    } )
                    .catch( error => {
                        this.catchError(error)
                    } )
            }
		},
		
		async mounted() {
			$("body").css('background-image', 'none')
			$("body").css('margin-top', '0px')
			this.hostname = hostname

			const script = document.createElement('script')
			script.src = 'assets/js/argon.js'
			document.body.appendChild(script)
			
			if(!user) {
                await this.getUserApi()
                this.usuario = user
            } else {
                this.usuario = user
            }

            this.model = this.usuario

            this.openLoading()
			await this.getPaises()
            await this.getIdiomas()
            await this.getZonasHorarias()
            await this.getClients()
            Swal.close()
		},
		beforeMount() {
			document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				this.classHeader = 'header bg-gradient-gray-dark pb-6 d-flex align-items-center'
				this.classTextWelcome = 'mt-0 mb-5 text-orange'
			}
			if(hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'iproedomex.etciberoamerica.com' || hostname == 'ctm.etciberoamerica.com' || hostname == 'conalep-tamps.etciberoamerica.com' || hostname == 'conalep-gto.etciberoamerica.com' || hostname == 'conalep-ags.etciberoamerica.com' || hostname == 'tesecatepec.etciberoamerica.com' || hostname == 'conalep-ver.etciberoamerica.com' || hostname == 'conalep-yuc.etciberoamerica.com' || hostname == 'conalep-on.etciberoamerica.com' || this.hostname == 'itsloscabos.etciberoamerica.com' || this.hostname == 'conalep-chihuahua.etciberoamerica.com' || this.hostname == 'canacintra.etciberoamerica.com' || this.hostname == 'conalep-qro.etciberoamerica.com') {
				this.classHeader = 'header bg-gradient-light pb-6 d-flex align-items-center'
				this.classTextWelcome = 'mt-0 mb-5 text-purple'
			}
		}
	}
</script>
